import FreshwatchGroupManagerFunctional from '../../../../../customized/fresh-watch/components/Group/GroupManager/FreshwatchGroupManager';
import { ToggleComponent } from '../../../../../featureToggle';
import GroupManagerFunctional from './GroupManager';

export default ToggleComponent(GroupManagerFunctional, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchGroupManagerFunctional,
  },
});
